<template>
    <div :class="[
        'form-group',
        'form-group--float',
        'form-group--active', {
            'has-error': hasErrors,
            'form-group--disabled': disabled,
        }]">
        <label :for="name" class="control-label">
            <slot>{{ name }}</slot>{{ required ? ' *' : '' }}
        </label>

        <input
            class="form-control--file"
            type="file"
            ref="fileInput"
            v-bind="$attrs"
            :name="name"
            :id="name"
            :disabled="disabled"
            :multiple="multiple"
            :required="required"
            @change="onChange" />

        <ul v-if="multiple">
            <li v-for="(f, index) in files" :key="`${name}-${index}`">
                <strong>{{ f.name }}</strong>
                <el-button icon="el-icon-close" @click="() => onRemove(index)" />
            </li>
        </ul>

        <div v-if="hasErrors" class="form-group__errors">
            <p>{{ errors[0] }}</p>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
    name: 'SaxxUpload',
    props: {
        form: {
            required: true,
            type: String
        },
        name: {
            required: true,
            type: String
        },
        multiple: {
            required: false,
            type: Boolean,
            default: false
        },
        required: {
          required: false,
          type: Boolean,
          default: false
        },
    },
    computed: {
        ...mapGetters('forms', [
            'getField',
            'getErrors',
            'getFieldIsDisabled',
        ]),
        files() {
            return this.getField({
                form: this.form,
                field: this.name,
            });
        },
        errors() {
            return this.getErrors({
                form: this.form,
                field: this.name,
            });
        },
        hasErrors() {
            return this.errors.length > 0;
        },
        disabled() {
            return this.getFieldIsDisabled({ form: this.form, field: this.name });
        },
    },
    methods: {
        ...mapActions('forms', [
            'setField',
        ]),
        onChange(e) {
            const files = e.target.files;
            if (files.length <= 0) {
                return;
            }

            if (this.multiple) {
                this.setField({
                    form: this.form,
                    field: this.name,
                    value: [...this.files, ...files],
                });
                this.$refs.fileInput.value = null;

                return;
            }

            this.setField({
                form: this.form,
                field: this.name,
                value: files[0],
            });
        },
        onRemove(index) {
            if (this.multiple) {
                const files = this.files.filter((_, ind) => ind !== index);

                this.setField({
                    form: this.form,
                    field: this.name,
                    value: files,
                });

                return;
            }

            this.setField({
                form: this.form,
                field: this.name,
                value: null,
            });
        },
    },
}
</script>
